<template>
  <v-footer
    dense
    dark
    app
    fixed
    padless
    class="px-1"
    style="user-select: none;"
  >
    <div class="text-button font-weight-bold texto-cinza-claro">
      <span class="font-weight-medium texto-cinza-claro"> gestão</span>
      <span class="font-weight-bold texto-vermelho-escuro">web</span>
    </div>

    <v-spacer></v-spacer>
    <span class="text-button white--text font-weight-bold d-none d-sm-flex"
      >Megabit Locação de Softwares ®</span
    >
    <v-spacer></v-spacer>
    <div class="text-button font-weight-bold texto-cinza-claro d-xs-none">
      <v-icon left small :color="colorIconMdiClock">mdi-clock</v-icon>
      <span class="font-weight-bold text-lowercase">{{ localTime }}</span>
    </div>
  </v-footer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  data: () => {
    return {
      localTime: null,
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'authModule/getAuthUser',
    }),
    ...mapState('authModule', ['tokenInvalid', 'env']),
    tokenIsInvalid() {
      return this.tokenInvalid
    },
    isProduction() {
      return this.env === 'production'
    },
    colorIconMdiClock() {
      if (this.isProduction) return 'grey lighten-3'
      else return 'orange'
    },
  },
  created() {
    setInterval(async () => {
      let dateVar = new Date()
      this.localTime = this.f(dateVar.getDate())
      this.localTime += '/' + this.f(dateVar.getMonth() + 1)
      this.localTime += '/' + dateVar.getFullYear()
      this.localTime += ' ' + this.f(dateVar.getHours())
      this.localTime += ':' + this.f(dateVar.getMinutes())
      this.localTime += ':' + this.f(dateVar.getSeconds())
    }, 1000)
  },
  methods: {
    //Formata com 0 à esquerda hora, segundo ou minuto < 10
    f(n) {
      return n < 10 ? '0' + n : n
    },
  },
}
</script>

<style></style>
